import React, { createContext } from 'react';

const WizardStepperContext = createContext({

});

export default WizardStepperContext;
